const segmentsForm = {
  bindings: {
      selection: '<',
      segments: '<',
      onFormSubmit: '&',
      onFileUpload: '&',
      hasEdit: '<',
  },
  templateUrl: '/modules/pis-tool/segments/segments-form/segments-form.html',
  controller: 'SegmentsFormController',
};

angular
    .module('segments.module')
    .component('segmentsForm', segmentsForm);
